module.exports = __webpack_public_path__ + "static/media/Innovation_South_Greenland_2026_Logo.85178252.png";